export enum ExpenseTypeEnum {
    Meal = 1,
    Mileage = 2,
    Tolls = 3,
    Lodging = 4,
    Flight = 5,
    AirlineFee = 6,
    Baggage = 7,
    TaxiRideshare = 8,
    PublicTransit = 9,
    PrivateCarTransfer = 10,
    RentalCar = 11,
    RentalCarGas = 12,
    Rail = 13,
    Internet = 14,
    Medication = 15,
    Entertainment = 16,
    Translations = 17,
    ChildCare = 18,
    Parking = 19,
    Visa = 20,
    Other = 21,
}

export const expenseTypeRecord: Record<string, string> = {
    Meal: 'MEAL',
    Mileage: 'MILEAGE_MI_KM',
    Tolls: 'TOLLS',
    Lodging: 'LODGING',
    Flight: 'FLIGHT',
    AirlineFee: 'AIRLINE_FEE',
    Baggage: 'BAGGAGE',
    TaxiRideshare: 'TAXI_RIDESHARE',
    PublicTransit: 'PUBLIC_TRANSIT',
    PrivateCarTransfer: 'PRIVATE_CAR_TRANSFER',
    RentalCar: 'RENTAL_CAR',
    RentalCarGas: 'RENTAL_CAR_GAS',
    Rail: 'RAIL',
    Internet: 'INTERNET',
    Medication: 'MEDICATION',
    Entertainment: 'ENTERTAINMENT',
    Translations: 'TRANSLATIONS',
    ChildCare: 'CHILD_CARE',
    Parking: 'PARKING',
    Visa: 'VISA',
    Other: 'OTHER',
};
